import { IProxy } from "@interfaces/admin/proxy";
import { createSlice } from "@reduxjs/toolkit";
import { SliceAction } from "store/store";

const queryParamsLS = JSON.parse(window.localStorage.getItem("adminCustomersPage") || "{}");
const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

const isActivePage =  window.location.pathname.includes("customers") ;

const initialState: {
    activePaginationPage: number,
    activePaginationLimit: number,
    activeSearchIdParameter: string,
    activeFilter: "all" | "active",
    selectRows: number[],
    applytTo: "notActive" | "active" | "all" | "selected"
} = Object.assign(
    (isActivePage && Object.keys(queryParamsURL).length)
        ? {
            activePaginationPage: Number(queryParamsURL?.page || "1"),
            activePaginationLimit: Number(queryParamsURL?.limit || "50"),
            activeSearchIdParameter: queryParamsURL?.searchId || "",
            activeFilter: queryParamsURL.filter || "all",
        }
        : {
            activePaginationPage: Number(queryParamsLS?.page || "1"),
            activePaginationLimit: Number(queryParamsLS?.limit || "50"),
            activeSearchIdParameter: queryParamsLS?.searchId || "",
            activeFilter: queryParamsLS.filter || "all",
        }, {
    selectRows: [],
    applytTo: "selected" as "notActive" | "active" | "all" | "selected"
});

window.localStorage.setItem("adminCustomersPage", JSON.stringify({
    page: initialState.activePaginationPage,
    limit: initialState.activePaginationLimit,
    searchId: initialState.activeSearchIdParameter,
    filter: initialState.activeFilter,
}))

const customersSlice = createSlice({
    initialState,
    name: "customersAdminPage",
    reducers: {
        setActivePaginationPage(state, action: SliceAction<(typeof initialState)["activePaginationPage"]>) {
            window.localStorage.setItem("adminCustomersPage", JSON.stringify({
                page: action.payload,
                limit: state.activePaginationLimit,
                searchId: state.activeSearchIdParameter,
                filter: state.activeFilter,
            }))
            state.activePaginationPage = action.payload;
        },
        setActivePaginationLimit(state, action: SliceAction<(typeof initialState)["activePaginationLimit"]>) {
            window.localStorage.setItem("adminCustomersPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: action.payload,
                searchId: state.activeSearchIdParameter,
                filter: state.activeFilter,

            }))
            state.activePaginationLimit = action.payload;
        },
        setActiveSearchIdParameter(state, action: SliceAction<(typeof initialState)["activeSearchIdParameter"]>) {
            window.localStorage.setItem("adminCustomersPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: state.activePaginationLimit,
                searchId: action.payload,
                filter: state.activeFilter,

            }))
            state.activeSearchIdParameter = action.payload;
        },
        setActiveFilter(state, action: SliceAction<(typeof initialState)["activeFilter"]>) {
            window.localStorage.setItem("adminCustomersPage", JSON.stringify({
                page: state.activePaginationPage,
                limit: state.activePaginationLimit,
                searchId: state.activeSearchIdParameter,
                filter: action.payload
            }))
            state.activeFilter = action.payload;
        },

        addSelectRow(state, action: SliceAction<number>) {
            state.selectRows.push(action.payload);
        },
        removeSelectRow(state, action: SliceAction<number>) {
            state.selectRows = state.selectRows.filter(item => item !== action.payload);
        },
        setSelectRow(state, action: SliceAction<number[]>) {
            state.selectRows = action.payload;
        },

        setApplytTo(state, action: SliceAction<(typeof initialState)["applytTo"]>) {
            state.applytTo = action.payload;
        }
    },
});

const { reducer, actions } = customersSlice;

export default reducer;

export const {
    setActivePaginationPage,
    setActivePaginationLimit,
    setActiveSearchIdParameter,
    setActiveFilter,
    addSelectRow,
    removeSelectRow,
    setSelectRow,
    setApplytTo
} = actions;
